import Radio from '@space-core/components/form/radio'

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { Container } from './styles'
import type { RadioCardProps } from './types'

export default function RadioCard({
  value,
  checked,
  onChange,
  title,
  description,
  isDisabled,
  ariaLabelledBy
}: RadioCardProps) {
  const { t } = useTranslation()

  const titleClass = clsx('_font-weight-light _mb-0', {
    '_text-gray-900': !isDisabled,
    '_text-gray-400': isDisabled
  })

  const descriptionClass = clsx('_text-1 _font-weight _mb-0', {
    '_text-gray-900': !isDisabled,
    '_text-gray-400': isDisabled
  })

  return (
    <Container className='_d-flex _p-3 _align-items-center _w-full'>
      <Radio
        id={String(value)}
        value={value}
        checked={checked}
        disabled={isDisabled}
        data-test={String(value)}
        name='community-type-button'
        className='_mr-3 _ml-2 _mb-5'
        onChange={() => onChange(value)}
        aria-labelledby={ariaLabelledBy}
      />
      <div>
        <p className={titleClass}>{t(title)}</p>
        <p className={descriptionClass}>{t(description)}</p>
      </div>
    </Container>
  )
}
